<template>
  <div class="primary--text">

    <!--    <p>-->
    <!--      https://medium.com/@vivekdhumal/how-to-make-a-video-recorder-using-videojs-record-vue-and-laravel-c586fed455bd-->
    <!--    </p>-->


    <v-row v-if="isUploading">
      <v-col>
        <v-progress-linear

            v-model="uploadPercentage"
            color="grey accent-4"
        ></v-progress-linear>
        <div>Uploading: {{ uploadPercentage }} %</div>

      </v-col>
    </v-row>

    <v-row justify="center" v-if="!isUploading">
      <v-col cols="12">
        <v-alert
            type="error"
            color="red"
            v-if="error"
        >{{ error }}
        </v-alert>

        <!--        <p class="headline">{{question}}</p>-->

        <div class="text-center">
          <v-file-input
              ref="fileinpu"
              accept="video/*"
              placeholder="Pick a video"
              prepend-icon="mdi-camera"
              v-model="choosenVideoFile"
              @change="onFinisedRecording"
              style="display: none"
          ></v-file-input>

          <div>Choose a Video-File or start your camera to start recording.</div>
          <dialog-modal
              title="Record a video"
              btn-ok="OK"
              btn-cancel="Cancel"
              btn-cancel-icon=""
              btn-ok-icon=""

              @ok="$refs.fileinpu.$refs.input.click()"
          >
            <v-btn rounded x-large>
              <v-icon left>mdi-camera</v-icon>
              start
            </v-btn>
            <template v-slot:body>
              Please record your video in landscape mode...
              <v-img src="@/assets/rotate.gif"></v-img>
            </template>
          </dialog-modal>

          <!--          <v-btn rounded x-large @click="$refs.fileinpu.$refs.input.click()"><v-icon left>mdi-camera</v-icon>start</v-btn>-->

          <div v-if="choosenVideoFile">{{ choosenVideoFile.name }}</div>

        </div>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="!isUploading">
      <v-btn x-large rounded outlined color="#000000" @click="$emit('cancel')" class="ma-2">Cancel</v-btn>
      <v-btn x-large rounded color="#09b11c" @click="uploadVideo" v-if="recordedVideoFile" class="ma-2">Save & Send
        File
      </v-btn>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex';
import {isMobile} from 'mobile-device-detect';

import DialogModal from "@/components/DialogModal";
const fb = require('@/firebase/config.js');

export default {
  name: 'StepVideoMobile',
  components: {
    DialogModal
  },
  data: () => ({
    error: null,
    uploadPercentage: 0,
    isUploading: false,
    choosenVideoFile: null,
  }),
  // ...
  computed: {
    ...mapState({
      recordedVideoFile: state => state.recordedVideo,
      question: state => state.question,
      form: state => state.form
    }),
    ...mapState('user', {
      loggedin: state => state.loggedin,
      user: state => state.user,
      userClaims: state => state.claims,
    }),
    isMobileDevice() {
      return isMobile;
    }
  },
  methods: {


    onError(args) {
      console.log('on Record ERROR', args);
      this.videoRecorded = false;
      this.recordedVideo = null;
      this.error = args;
    },
    onFinisedRecording(args) {
      this.error = null;
      console.log('on Record FINISHED', args);
      this.videoRecorded = true;
      this.recordedVideo = args;
      this.$store.commit('setVideoFile', args);
    },

    uploadVideo() {
      var self = this;

      self.error = null;

      //this.player.record().saveAs({'video': 'my-video'});
      //https://github.com/collab-project/videojs-record/blob/master/examples/upload/fine-uploader.html
      //https://github.com/collab-project/videojs-record/blob/master/examples/upload/jquery.fileupload.html
      var videoFile = this.recordedVideoFile;
      console.log('finished recording: ', videoFile);

      console.log('finished recording, form: ', this.form);
      // upload data to server
      // var filesList = [videoFile];
      let formData = new FormData();
      //formData.append('filesList', filesList);

      const q = {
        uid: this.user.uid,
        question: this.question
      }

      formData.append('data', JSON.stringify({...this.form, ...q}));
      formData.append('sequenceId', this.sequenceId);
      formData.append('videoFile', this.recordedVideoFile);

      /*
        Make the request to the POST /select-files URL
      */
      this.isUploading = true;
      // this.$http.post('https://apps.limemotion.com/limemotion-video-tool/index.php',
      //     formData,
      //     {
      //       headers: {
      //         'Content-Type': 'multipart/form-data'
      //       },
      //       onUploadProgress: (e) => {
      //         console.log(e);
      //         if (e.lengthComputable) {
      //           console.log(e.loaded / e.total * 100);
      //           self.uploadPercentage = (e.loaded / e.total * 100).toFixed(2);
      //         }
      //       }
      //     })
      //     .then(function (response) {
      //       console.log('SUCCESS!!', response.data);
      //       self.isUploading = false;
      //
      //
      //       if (response.data.status == 'success') {
      //         self.$emit('finished');
      //       } else {
      //         self.error = response.data.error;
      //       }
      //
      //     })
      //     .catch(function (e) {
      //       console.log('FAILURE!! ' + e);
      //       self.error = e;
      //     })
      //     .finally(() => {
      //       self.isUploading = false;
      //     })


      const metadata = { customMetadata: {...this.form, ...q}};
      const storageRef = fb.storage
          .ref(`media/${this.user.uid}_` + new Date().getTime() + '_' + this.choosenVideoFile.name)
          .put(videoFile, metadata);

      storageRef.on(`state_changed`, snapshot => {
            let upl = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            self.uploadPercentage = upl.toFixed(2);
            console.log(upl)
          }, error => {
            console.log(error.message);
            self.error = error.message;
          },
          () => {
            //this.uploadValue = 100;
            self.isUploading = false;
            self.$emit('finished');
            // storageRef.snapshot.ref.getDownloadURL().then((url) => {
            //   console.log('uplaod url', url);
            //
            // });
          }
      );
    }

  }
}
</script>
